"use strict";

/******* SLIDERS */
import Glide from "@glidejs/glide";
// Najde všechny elementy s třídou 'glide'
const glideElements = document.querySelectorAll(".glide");
// Vytvoří pole ID z těchto elementů
const sliders = Array.from(glideElements).map((element) => element.id);
// Přidejte další ID, pokud máte více sliderů
window.addEventListener("DOMContentLoaded", () => {
  sliders.forEach((sliderId) => {
    new Glide(`#${sliderId}`, {
      type: "carousel",
      startAt: 0,
      perView: 1,
      focusAt: "center",
      gap: 0,
    }).mount();
  });
});
/******* SLIDERS  */

/******* lightbox */
// GLightbox je načten z CDN v base.html
// Inicializuj lightbox pouze pro elementy, které nejsou součástí galerie
document.addEventListener("DOMContentLoaded", function () {
  if (typeof GLightbox !== "undefined") {
    const lightbox = GLightbox({
      selector: '.glightbox:not([data-gallery="gallery"])',
    });
  }
});

/******* paralax */
const paralaxObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add(entry.target.dataset.paralax);
      paralaxObserver.unobserve(entry.target);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".paraX").forEach((elm) => {
    paralaxObserver.observe(elm);
  });
});

// SmoothScroll inicializace
import SmoothScroll from "smooth-scroll";
new SmoothScroll('a[href*="#"]', {
  header: "header",
  speed: 300,
  speedAsDuration: true,
});

// NodeList.prototype.forEach() polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// clickToggleClass - BEGIN
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("*[data-click-toggle-class]").forEach((elm) => {
    elm.addEventListener("click", (event) => {
      event.preventDefault();

      const classes = event.currentTarget.dataset.clickToggleClass.split("|");
      const targets = event.currentTarget.dataset.clickToggleTarget
        ? [...document.querySelectorAll(event.target.dataset.clickToggleTarget)]
        : [event.target];
      const toggledClases = targets[0].classList.contains(classes[0])
        ? {
            remove: classes[0],
            add: classes[1],
          }
        : {
            remove: classes[1],
            add: classes[0],
          };
      targets.forEach((elm) => {
        elm.classList.remove(toggledClases.remove);
        elm.classList.add(toggledClases.add);
      });
    });
  });
});
// clickToggleClass - END

/* LANG SWICHER */
// Funkce pro zobrazení/skrytí menu
function toggleMenu() {
  const menu = document.getElementById("header_barLangWrap");
  menu.style.display = menu.style.display === "block" ? "none" : "block";
}

// Otevření menu při kliknutí
document.getElementById("header_barLang").addEventListener("click", toggleMenu);

// Zobrazení menu při najetí myší
document
  .getElementById("header_barLang")
  .addEventListener("mouseenter", function () {
    document.getElementById("header_barLangWrap").style.display = "block";
  });

// Skrytí menu při odjetí myší
document
  .getElementById("header_barLangWrap")
  .addEventListener("mouseleave", function () {
    document.getElementById("header_barLangWrap").style.display = "none";
  });

// Skrytí menu při opakovaném kliknutí
document
  .getElementById("header_barLangWrap")
  .addEventListener("click", toggleMenu);
/* LANG SWICHER KONEC */

/* MENU START */
window.addEventListener("DOMContentLoaded", () => {
  const openMenu = document.querySelector(".menu-open");
  const closeMenu = document.querySelector(".menu-close");
  const menuDiv = document.querySelector(".ozmenu");
  const menu = document.querySelector(".ozmenu-nav");

  if (!menu) {
    return; // Menu element neexistuje, ukonči inicializaci
  }

  const dropDowns = menu.getElementsByClassName("nav-dropdown");
  const dropDownsChild = menu.querySelectorAll(".dropdown .nav-dropdown");

  if (openMenu) {
    openMenu.addEventListener("click", menuToggle);
  }
  if (closeMenu) {
    closeMenu.addEventListener("click", menuToggle);
  }

  document.body.insertAdjacentHTML("beforeend", "<div id='menu-overlay'></div>");
  const menuOverlay = document.querySelector("#menu-overlay");
  if (menuOverlay) {
    menuOverlay.addEventListener("click", menuToggle);
  }

  function menuToggle() {
    if (menuDiv) {
      menuDiv.classList.toggle("active");
    }
    document.body.classList.toggle("hide-scrolling");
    document.body.classList.toggle("mobile-menu-active");
    const overlay = document.getElementById("menu-overlay");
    if (overlay) {
      overlay.classList.toggle("show");
    }
  }

  let i = 0;

  for (i = 0; i < dropDownsChild.length; i++) {
    dropDownsChild[i].classList.add("child");
    dropDownsChild[i].dataset.clicked = "false"; // Inicializace stavu kliknutí

    dropDownsChild[i].addEventListener("click", function (e) {
      if (this.dataset.clicked === "false") {
        e.preventDefault(); // Zabránit prokliku při prvním kliknutí
        this.dataset.clicked = "true"; // Nastavit, že uživatel kliknul poprvé
      } else {
        this.dataset.clicked = "false"; // Při dalším kliknutí obnovit na false
      }
      this.classList.toggle("opened");
    });
  }

  for (i = 0; i < dropDowns.length; i++) {
    if (!dropDowns[i].classList.contains("child")) {
      dropDowns[i].classList.add("parent");
      dropDowns[i].dataset.clicked = "false"; // Inicializace stavu kliknutí

      dropDowns[i].addEventListener("click", function (e) {
        if (this.dataset.clicked === "false") {
          e.preventDefault(); // Zabránit prokliku při prvním kliknutí
          this.dataset.clicked = "true"; // Nastavit, že uživatel kliknul poprvé
        } else {
          this.dataset.clicked = "false"; // Při dalším kliknutí obnovit na false
        }
        this.classList.toggle("opened");
      });
    }
  }
});

/* MENU END */

/* ČAS na BALI a v ČR START */

window.addEventListener("DOMContentLoaded", () => {
  function updateTimes() {
    // Funkce na získání aktuálního času ve formátu H:i
    function formatTime(date) {
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Získání aktuálního času v ČR (časové pásmo UTC+1 nebo UTC+2 při letním čase)
    const czechTime = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Prague" })
    );

    // Získání aktuálního času na Bali (časové pásmo UTC+8)
    const baliTime = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Makassar" })
    );

    // Aktualizace obsahu elementů
    document.querySelectorAll(".timeCS").forEach((span) => {
      span.textContent = formatTime(czechTime);
    });
    document.querySelectorAll(".timeBali").forEach((span) => {
      span.textContent = formatTime(baliTime);
    });
  }

  // Aktualizace při načtení stránky a každých 60 vteřin
  updateTimes();
  setInterval(updateTimes, 60000);
});

/* ČAS na BALI a v ČR END */

/******* TIME-BASED BACKGROUND
// Dynamické změna background-image podle denní doby
function setTimeBasedBackground() {
  // Zkontroluj, zda element .hp_header existuje v DOM
  const headerElement = document.querySelector('.hp_header');
  if (!headerElement) {
    return; // Element neexistuje, ukonči funkci
  }

  const now = new Date();
  const hour = now.getHours();

  // Odstraň předchozí třídy
  headerElement.classList.remove('hp_header_day', 'hp_header_night');

  // Denní doba: 8:00 - 19:59 (přidá třídu hp_header_day)
  // Noční doba: 20:00 - 7:59 (přidá třídu hp_header_night)
  if (hour >= 8 && hour < 20) {
    // Den
    headerElement.classList.add('hp_header_day');
  } else {
    // Noc
    headerElement.classList.add('hp_header_night');
  }
}

// Spusť při načtení stránky
document.addEventListener('DOMContentLoaded', function() {
  setTimeBasedBackground();
});

// Volitelně: aktualizuj každou hodinu (pouze pokud element existuje)
setInterval(function() {
  if (document.querySelector('.hp_header')) {
    setTimeBasedBackground();
  }
}, 3600000); // 3600000 ms = 1 hodina
*/
